<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <DatePickerRange title="备注时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>

        <div class="dialog-input-item">
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
<!--          <label>添加人</label>-->
<!--          <el-input type="text" v-model="searchValue" placeholder="请输入添加人" class="select-item"  clearable>-->
<!--            <template #prefix>-->
<!--              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>-->
<!--            </template>-->
<!--          </el-input>-->
        </div>
        <div class="dialog-input-item">
          <label>备注类型</label>
          <el-select v-model="type" placeholder="Select" class="select-item">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
        <div class="dialog-input-btn">
          <ElButtons type="success" icon="plus" @click="add"> 添加 </ElButtons>
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        @cell-click="toggleSelection"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="createTime" label="时间" width="200"/>
      <el-table-column property="content" label="备注">
        <template #default="scope">
          <span v-high-light="{value: scope.row.content}">{{scope.row.content}}</span>
        </template>
      </el-table-column>
      <el-table-column property="adminName" label="添加人" width="200"/>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import { getUserRemarkPageList} from '@/api/url';
import Dialog from '../../assets/js/dialog'
import AddUserRemarkDialog from './AddUserRemarkDialog';
import DatePickerRange from "@/components/DatePickerRange";
import SearchComponents from "@/components/SearchComponents";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      pageDataList: [],
      id: this.value.id,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      typeArray: [
        {label: '不限', value: -1},
        {label: '常规备注', value: 0},
        {label: '预约备注', value: 1},
        {label: '充值备注', value: 3},
        {label: '回访备注', value: 3},
      ],
      type: this.value.type?this.value.type:-1,

      //搜索
      searchTypeList: [
        {label : '添加人', value : 1},
        {label : '客户备注', value : 2}
      ],
      searchType: 1,
      searchValue: '',
    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.id;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['type'] = this.type;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getUserRemarkPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.sort(this.compare)
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          if(this.pageDataList.length > 3) {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList.slice(0,3)));
          } else {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList));
          }
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },
    add() {
      Dialog.open({
        title: '添加备注',
        component: AddUserRemarkDialog,
        data: {
          id: this.id
        },
        confirm: (result) => {
          this.getPage();
        }
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.label == '备注') {
        Dialog.open({
          title: '编辑备注',
          component: AddUserRemarkDialog,
          data: {
            id: this.id,
            content: row.content,
            remarkId: row.id,
            sourceId: row.sourceId,
            sourceType: row.sourceType,
            type: row.type,
          },
          confirm: (result) => {
            this.getPage();
          }
        })
      }
    }

  },
  mounted() {
    sessionStorage.removeItem('userLog');
    this.getPage();
  }
}
</script>

<style>

</style>
